import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';

// Prefabs
import ButtonRounded from '../prefabs/ButtonRounded.js';
import MissionTitle from '../prefabs/MissionTitre.js';
import NavTitre from '../prefabs/NavTitre.js';
import BlueMessageBox from '../prefabs/BlueMessageBox.js';
import ImageSlider from '../prefabs/ImageSlider.js';
import CircularAudioPlayer from '../prefabs/CircularAudioPlayer.js';
import AnswerFeedBack from '../prefabs/AnswerFeedBack.js';

// Data
import rorqualperduData from '../data/Mission2.js';
import { Sizes } from '../consts/Sizes.js';
import { tags } from '../consts/Tags.js';

export default class Mission2 extends AbstractScene {
    constructor() {
        super({
            key: 'Mission2',
        });
    }
    init(data) {
        this._init(data);
        this.currentIndex = 0;
        this.mot = null;
        this.phrasesDebriefing = [];
    }

    preload() {
        this._preload();
        this.videoKey = 'posidonieVideo';
        this.preTarget = () => this.scene.start('Mission1');
        this.postTarget = () => {
            this.showIntro();
        };
        this.allControls = [];
        this.isPlaying = false;
        this.isDraging = false;
    }

    update() {
        super.update();
        this.player?.update();
        this.player2?.update();
        this.player3?.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.Beige);
        this.cameras.main.fadeIn(1000);

        // mission data
        this.videoKey = this.getText('Mission2', 'videoKey');

        this.showVideo(this.videoKey);
    }

    showIntro() {
        this.sceneContainer = this.add.container(this.width / 2, this.height / 2);

        // background
        this.background = this.add.image(0, 0, 'background-activite-2').setOrigin(0.5);

        this.sceneContainer.add(this.background);

        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '2', this.getText('Mission2', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();

        // Fog (créé invisible au départ)
        const fog = this.add.graphics();
        const containerWidth = this.sceneContainer.width || this.scale.width;
        const containerHeight = this.sceneContainer.height || this.scale.height;

        const fogStartY = containerHeight * 0.5 - containerHeight / 2;
        const fogEndY = containerHeight / 2;
        const fogHeight = fogEndY - fogStartY;

        for (let i = 0; i < fogHeight; i++) {
            const alpha = (i / fogHeight) * 0.8;
            fog.fillStyle(Colors.Elmt.DarkBlue, alpha);
            fog.fillRect(-containerWidth / 2, fogStartY + i, containerWidth, 1);
        }

        this.sceneContainer.add(fog);

        // MissionTitle au-dessus
        this.missionTitle = new MissionTitle(
            this,
            0,
            0,
            2,
            this.getText('Mission2', 'mission'),
            this.getText('Mission2', 'titre'),
            this.getText('Mission2', 'intro'),
            this.scaleX
        );
        this.missionTitle.setDepth(2);

        this.sceneContainer.add(this.missionTitle);
        // Bouton
        const button = this.add.existing(
            new ButtonRounded(
                this,
                458 * this.scaleX + 86,
                this.cameras.main.height - 32 - 32,
                86 * 2,
                32 * 2,
                this.getText('Mission2', 'buttonLabel1'),
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.White,
                true,
                false,
                'arrow-right',
                null
            )
        );
        button.setAlpha(0); // Start invisible

        // ▶️ Sequence d'animations
        this.missionTitle.animateIn(); // Animation du titre de la mission

        this.tweens.add({
            targets: button,
            alpha: 1,
            duration: 1000,
            ease: 'Sine.easeIn',
        });

        this.uiElements = [fog, this.missionTitle, button];
        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.input.enabled = false;
            // Fade out tout sauf la nav
            this.tweens.add({
                targets: this.uiElements,
                alpha: 0,
                duration: 500,
                onComplete: () => {
                    this.tweens.add({
                        targets: this.background,
                        alpha: 0,
                        duration: 500,
                        onComplete: () => {
                            this.background.setTexture('background-activite-2b').setOrigin(0, 0);
                            this.background.y = -this.height;
                            this.background.x = -this.width / 2;
                            this.tweens.add({
                                targets: this.background,
                                alpha: 1,
                                duration: 500,
                                onComplete: () => {
                                    this.addConsigne();
                                    this.input.enabled = true;
                                },
                            });
                        },
                    });
                },
            });
        });
    }

    addConsigne() {
        this.isClosing = false;
        const elementsToAnimate = [];

        // add cadre consigne
        const cadre = this.add
            .image(this.width / 2, this.height / 2, 'cadre-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(cadre);

        // add consigne text
        let txt;
        let wdt;
        if (this.game.data.level === 0) {
            (txt = this.getText('Mission2', 'consigneNiveau0')), (wdt = 700);
        } else {
            (txt = this.getText('Mission2', 'consigneNiveau1')), (wdt = 600);
        }
        const texte = new BlueMessageBox(this, this.cameras.main.centerX, 450, txt, wdt);

        // add icone close
        const close = this.add
            .image(this.width / 2, 70 * 2 + 64 / 2, 'cta-close')
            .setOrigin(0.5, 0.5)
            .setScale(0)
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => {
                if (this.isClosing) return; // ⛔ empêche de recliquer
                this.isClosing = true;

                this.input.enabled = false;

                const elementsToHide = [cadre, texte, close, loupe];
                let completed = 0;

                elementsToHide.forEach((el) => {
                    this.tweens.add({
                        targets: el,
                        scale: 0,
                        duration: 300,
                        ease: 'Back.easeIn',
                        onComplete: () => {
                            completed++;
                            if (completed === elementsToHide.length) {
                                cadre.destroy();
                                texte.destroy();
                                close.destroy();
                                loupe.destroy();

                                // quand tous les éléments ont disparu, on relance l'activité
                                this.addSlider();

                                // Réinitialise le flag si besoin pour autoriser plus tard
                                this.isClosing = false;

                                // this.input.enabled = true;
                            }
                        },
                    });
                });
            });

        elementsToAnimate.push(close);

        // icone consigne
        const loupe = this.add
            .image(266 * this.scaleX + 50, 112 * 2 + 122 / 2 + 20, 'consigne-activite-2')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(loupe);

        // Appliquer l'animation scale up avec rebound
        elementsToAnimate.forEach((el, index) => {
            this.tweens.add({
                targets: el,
                scale: 1,
                duration: 500,
                ease: 'Back.Out',
                delay: index * 100, // léger décalage pour un effet en cascade
            });
        });
    }

    addSlider() {
        this.input.enabled = true;
        const keys = [
            'slider-img-1-activite-2',
            'slider-img-2-activite-2',
            'slider-img-3-activite-2',
            'slider-img-4-activite-2',
            'slider-img-5-activite-2',
            'slider-img-6-activite-2',
            'slider-img-7-activite-2',
            'slider-img-8-activite-2',
        ]; // Tes clés d’images préchargées

        this.goodIndices = [1, 4, 6]; // ← à adapter selon les images correctes

        const slider = new ImageSlider(this, this.cameras.main.centerX, 300, keys);

        this.players = [];
        if (this.game.data.level === 0) {
            this.player = new CircularAudioPlayer(
                this,
                60 + 64,
                this.height - 70,
                'audioBateau',
                'slider-img-3-activite-2',
                50,
                10,
                0,
                this.currentIndex
            );
            this.player2 = new CircularAudioPlayer(
                this,
                60 + 64 + this.player.width + 40 + 90,
                this.height - 70,
                'audioPlage',
                'slider-img-5-activite-2',
                50,
                10,
                1,
                this.currentIndex
            );
            this.player3 = new CircularAudioPlayer(
                this,
                60 + 64 + this.player.width + 40 + this.player2.width + 40 + 180,
                this.height - 70,
                'audioTravaux',
                'slider-img-2-activite-2',
                50,
                10,
                2,
                this.currentIndex
            );
            this.players = [this.player, this.player2, this.player3];
        } else {
            this.player = new CircularAudioPlayer(
                this,
                60 + 64,
                this.height - 60,
                'audioFull',
                0,
                50,
                10,
                this.currentIndex
            );
            this.players = [this.player];
        }

        const playersContainer = this.add.container(0, 0);
        playersContainer.add(this.players);

        this.missionInfo = this.add.text(
            playersContainer.width + 550,
            this.height - 110,
            this.getText('Mission2', 'info'),
            {
                fontSize: Sizes.Text.h4,
                fontFamily: 'Monteserrat',
                color: Colors.Text.White,
                wordWrap: { width: 500 },
            }
        );

        this.bouteilleActivite = this.add.image(
            this.width - 250,
            this.height - 70,
            'bouteille-vide-activite-2'
        );
        const icon1 = this.add.image(this.width - 250, this.height - 70, 'icone_inter');
        const icon2 = this.add.image(this.width - 300, this.height - 70, 'icone_inter');
        const icon3 = this.add.image(this.width - 350, this.height - 70, 'icone_inter');

        this.interIcons = [icon3, icon2, icon1];

        this.UIactivite = [
            slider,
            playersContainer,
            this.missionInfo,
            this.bouteilleActivite,
            icon1,
            icon2,
            icon3,
            this.player,
            this.player2,
            this.player3,
        ];
        this.addBurgerMenu(3);
    }

    addPopupDebrief(key) {
        const whiteRectangle = this.add
            .rexRoundRectangle(
                this.cameras.main.centerX,
                this.cameras.main.centerY,
                440 * 2.5,
                224 * 2.2,
                20,
                Colors.Elmt.White
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        const beigeRectangle = this.add
            .rexRoundRectangle(
                this.cameras.main.centerX - (440 * 1.25) / 2,
                this.cameras.main.centerY,
                440 * 1.25,
                224 * 2.2,
                20,
                Colors.Elmt.Beige
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        const solderRectangle = this.add
            .rectangle(
                this.cameras.main.centerX - 100,
                this.cameras.main.centerY,
                220,
                224 * 2.2,

                Colors.Elmt.Beige
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        const titreDebrief = this.add
            .text(
                beigeRectangle.x / 2 + beigeRectangle.width / 2,
                beigeRectangle.y / 2 + beigeRectangle.height / 2 - 220,
                this.getText('Mission2', 'endTitre'),
                {
                    fontSize: Sizes.Text.h1,
                    fontFamily: 'Binx',
                    color: Colors.Text.BleuNovotel,
                    wordWrap: { width: 500 },
                }
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        const textDebrief1 = this.add
            .text(
                beigeRectangle.x / 2 + beigeRectangle.width / 2,
                beigeRectangle.y / 2 + beigeRectangle.height / 2 - 150,
                this.getText('Mission2', `debriefingText1${[this.currentIndex]}`),
                {
                    fontSize: Sizes.Text.p,
                    fontFamily: 'Monteserrat',
                    color: Colors.Text.DarkBlue,
                    wordWrap: { width: 500 },
                }
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        const textDebrief2 = this.add
            .text(
                whiteRectangle.x + whiteRectangle.width / 4,
                this.cameras.main.centerY - 60,
                this.getText('Mission2', `debriefingText2${[this.currentIndex]}`),
                {
                    fontSize: Sizes.Text.p,
                    fontFamily: 'Monteserrat',
                    color: Colors.Text.DarkBlue,
                    wordWrap: { width: 500 },
                }
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        const phraseCharade = this.add
            .text(
                whiteRectangle.x + whiteRectangle.width / 4,
                this.cameras.main.centerY + 40,
                this.getText('Mission2', `phrasesDebriefing${[this.currentIndex]}`),
                {
                    fontSize: `${14 * this.scaleX}px`,
                    fontFamily: 'Binx',
                    color: Colors.Text.DarkBlue,
                    wordWrap: { width: 500 },
                    align: 'center',
                    lineSpacing:
                        this.game.data.lang === 'pol' ? -2 * this.scaleX : -8 * this.scaleX,
                }
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0)
            .setScale(0);

        this.phrasesDebriefing.push(phraseCharade.text);

        const bouteilleVide = this.add
            .image(
                whiteRectangle.x + whiteRectangle.width / 4,
                this.cameras.main.centerY - 110,
                'bouteille-vide-activite-2'
            )
            .setScale(0.4)
            .setOrigin(0.5, 0.5)
            .setAlpha(0);
        bouteilleVide.setRotation(Phaser.Math.DegToRad(-5));

        // Add the image first to get its dimensions
        const imageDebrief = this.add
            .image(beigeRectangle.x / 2 + beigeRectangle.width / 2, beigeRectangle.y + 100, key)
            .setScale(0.7)
            .setOrigin(0.5, 0.5)
            .setAlpha(0);
        imageDebrief.setRotation(Phaser.Math.DegToRad(-4)).setDepth(1);

        // Calculate frame size based on image size and border
        const border = 6;
        const frameWidth = imageDebrief.displayWidth + border * 2;
        const frameHeight = imageDebrief.displayHeight + border * 2;
        const shadowOffset = 10;
        const imageDebriefShadow = this.add
            .rexRoundRectangle(
                imageDebrief.x + shadowOffset,
                imageDebrief.y + shadowOffset,
                frameWidth,
                frameHeight,
                8,
                0x000000
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0.15)
            .setDepth(0)
            .setAlpha(0);
        imageDebriefShadow.setRotation(Phaser.Math.DegToRad(-4));

        const imageDebriefFrame = this.add
            .rexRoundRectangle(
                imageDebrief.x,
                imageDebrief.y,
                frameWidth,
                frameHeight,
                8,
                Colors.Elmt.White
            )
            .setOrigin(0.5, 0.5)
            .setScale(1)
            .setAlpha(0); // No need to scale, already sized
        imageDebriefFrame.setStrokeStyle(border, Colors.Elmt.White);
        imageDebriefFrame.setRotation(Phaser.Math.DegToRad(-4)).setDepth(0);

        const checkIcon = this.add
            .image(
                beigeRectangle.x / 2 + beigeRectangle.width / 2 - 180,
                beigeRectangle.y + 10,
                'icone_check'
            )
            .setOrigin(0.5, 0.5)
            .setDepth(3)
            .setAlpha(0)
            .setScale(0);

        const btnContinuer = this.add
            .existing(
                new ButtonRounded(
                    this,
                    whiteRectangle.x + whiteRectangle.width / 4,
                    this.cameras.main.centerY + 180,
                    102 * 2,
                    32 * 2,
                    this.getText('Mission2', 'buttonLabel2'),
                    Colors.Text.White,
                    Colors.Elmt.BleuNovotel,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right-white',
                    null
                )
            )
            .setAlpha(0);

        this.UIpopupDebrief = [
            whiteRectangle,
            beigeRectangle,
            titreDebrief,
            textDebrief1,
            textDebrief2,
            phraseCharade,
            imageDebrief,
            imageDebriefFrame,
            imageDebriefShadow,
            btnContinuer,
            solderRectangle,
            bouteilleVide,
        ];

        this.tweens.add({
            targets: [
                whiteRectangle,
                beigeRectangle,
                titreDebrief,
                textDebrief1,
                textDebrief2,
                imageDebrief,
                imageDebriefFrame,
                checkIcon,
                btnContinuer,
                solderRectangle,
                bouteilleVide,
            ],
            alpha: 1,
            delay: 1000,
            duration: 500,
            ease: 'Sine.easeOut',
            onComplete: () => {
                this.tweens.add({
                    targets: checkIcon,
                    alpha: 1,
                    scale: 1,
                    duration: 300,
                    ease: 'Back.easeOut',
                    onComplete: () => {
                        this.tweens.add({
                            targets: phraseCharade,
                            alpha: 1,
                            scale: 1,
                            duration: 300,
                            ease: 'Back.easeOut',
                        });
                    },
                });
            },
        });

        this.tweens.add({
            targets: [imageDebriefShadow],
            alpha: 0.15,
            delay: 1000,
            duration: 500,
            ease: 'Sine.easeOut',
        });

        btnContinuer.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.currentIndex++;
            this.players.forEach((player) => {
                if (player.isPlaying) player.toggleAudio();
                player.setActiveIndex(this.currentIndex); // ⬅️ clé
            });
            const phrasesDebrefiengLength = 3;
            if (this.currentIndex >= phrasesDebrefiengLength) {
                this.showNextScreen();
            }
            this.tweens.add({
                targets: [
                    whiteRectangle,
                    beigeRectangle,
                    titreDebrief,
                    textDebrief1,
                    textDebrief2,
                    imageDebrief,
                    imageDebriefFrame,
                    imageDebriefShadow,
                    checkIcon,
                    btnContinuer,
                    solderRectangle,
                    bouteilleVide,
                    phraseCharade,
                ],
                alpha: 0,
                duration: 400,
                ease: 'Sine.easeIn',
                onComplete: () => {
                    phraseCharade.destroy();

                    titreDebrief.destroy();
                    textDebrief1.destroy();
                    textDebrief2.destroy();
                    beigeRectangle.destroy();
                    solderRectangle.destroy();
                    whiteRectangle.destroy();
                    imageDebrief.destroy();
                    imageDebriefShadow.destroy();
                    imageDebriefFrame.destroy();
                    checkIcon.destroy();
                    btnContinuer.destroy();
                    this.showActivite();
                },
            });
        });
    }

    showNextScreen() {
        let xOffsetPhrasePositions = 0;
        let yOffsetPhrasePositions = 0;
        let yOffsetIconeHelp = 0;
        /* this.destroyActivite(); */

        const blocker = this.add
            .rectangle(
                this.width / 2,
                this.height / 2,
                this.width,
                this.height,
                Colors.Elmt.Beige,
                1
            )
            .setDepth(1);

        const rightRect = this.add
            .rectangle(
                this.width * 0.75,
                this.height / 2,
                this.width / 2,
                this.height,
                Colors.Elmt.White,
                1
            )
            .setDepth(2);

        // Nav (titre-nav-activite-1) – commence plus haut
        const navTitre = this.add
            .existing(
                new NavTitre(this, 200, 0, '2', this.getText('Mission2', 'titre'), this.scaleX)
            )
            .setDepth(101);

        navTitre.showWithAnimation();

        // Add the bottle in the middle of the left rectangle
        const leftRectCenterX = this.width / 4;
        const leftRectCenterY = this.height / 2;
        const bouteilleVide = this.add
            .image(leftRectCenterX, leftRectCenterY - 150, 'bouteille-vide-activite-2')
            .setScale(0.4)
            .setDepth(2)
            .setOrigin(0.5, 0.5);
        bouteilleVide.setRotation(Phaser.Math.DegToRad(-5));

        if (this.game.data.lang === 'it') {
            yOffsetIconeHelp = -20;
        } else if (this.game.data.lang === 'pol') {
            yOffsetIconeHelp = -20;
        } else if (this.game.data.lang === 'pol') {
            yOffsetIconeHelp = -20;
        } else if (this.game.data.lang === 'de') {
            yOffsetIconeHelp = -30;
        }

        const iconeHelpPositions = [-70 + yOffsetIconeHelp, 30, 125 - yOffsetIconeHelp];
        const iconeHelps = iconeHelpPositions.map((offsetY) =>
            this.add
                .image(leftRectCenterX - 280, leftRectCenterY + offsetY, 'icone_help')
                .setDepth(2)
                .setOrigin(0.5, 0.5)
        );

        if (this.game.data.lang === 'it') {
            xOffsetPhrasePositions = -20;
            yOffsetPhrasePositions = 20;
        } else if (this.game.data.lang === 'pol') {
            xOffsetPhrasePositions = 0;
            yOffsetPhrasePositions = 5;
        } else if (this.game.data.lang === 'de') {
            xOffsetPhrasePositions = 0;
            yOffsetPhrasePositions = 30;
        }

        // Affiche dynamiquement toutes les phrases de charade
        const phrasePositions = [
            { x: 150, y: leftRectCenterY - 50, width: 500 },
            { x: 150, y: leftRectCenterY + 50 + yOffsetPhrasePositions, width: 500 },
            {
                x: 150,
                y: leftRectCenterY + 150 + 1.5 * yOffsetPhrasePositions,
                width: 500,
            },
        ];

        this.phrasesDebriefingTexts = [];

        this.phrasesDebriefing.forEach((phrase, i) => {
            const pos = phrasePositions[i];
            const textObj = this.add
                .text(pos.x, pos.y, `"${phrase}"`, {
                    fontSize: `${12 * this.scaleX}px`,
                    fontFamily: 'Binx',
                    color: Colors.Text.DarkBlue,
                    wordWrap: { width: pos.width },
                    align: 'left',
                    lineSpacing: -4 * this.scaleX,
                })
                .setDepth(2)
                .setOrigin(0, 0.5);
            this.phrasesDebriefingTexts.push(textObj);
        });

        // Center the text in the right white rectangle
        const rightRectCenterX = this.width * 0.75;
        const rightRectCenterY = this.height / 2;

        const textRectangle1 = this.add
            .rexBBCodeText(
                rightRectCenterX,
                rightRectCenterY - 220,
                this.getText('Mission2', 'debriefingText3'),
                {
                    fontSize: Sizes.Text.p,
                    color: Colors.Text.DarkBlue,
                    fontFamily: 'Monteserrat',
                    backgroundColor: 'transparent',
                    tags: tags,
                    align: 'center',
                }
            )
            .setDepth(2)
            .setOrigin(0.5);

        const textRectangle4 = this.add
            .rexTagText(
                rightRectCenterX,
                rightRectCenterY - 40,
                this.getText('Mission2', 'debriefingText4'),
                {
                    fontSize: `${18 * this.scaleX}px`,
                    color: Colors.Text.DarkBlue,
                    fontFamily: 'Binx',
                    backgroundColor: 'transparent',
                    tags: tags,
                    align: 'center',
                    lineSpacing:
                        this.game.data.lang === 'pol' ? -2 * this.scaleX : -8 * this.scaleX,
                }
            )
            .setDepth(2)
            .setOrigin(0.5);

        // ajote des mots cles clicables
        const motsCles = [
            this.getText('Mission2', 'motcle1'),
            this.getText('Mission2', 'motcle2'),
            this.getText('Mission2', 'motcle3'),
        ];
        const motsClesStartY = rightRectCenterY + 100;
        const motsClesStartX = rightRectCenterX - 180;
        const motsClesRects = [];

        motsCles.forEach((mot, i) => {
            const rect = this.add
                .rexRoundRectangle(
                    motsClesStartX + i * 180,
                    motsClesStartY,
                    160,
                    44,
                    16,
                    Colors.Elmt.Beige
                )
                .setOrigin(0.5)
                .setDepth(2)
                .setStrokeStyle(0, 0x000000)
                .setInteractive({ cursor: 'pointer' });

            const label = this.add
                .text(rect.x, rect.y, mot, {
                    fontSize: `${10 * this.scaleX}px`,
                    fontFamily: 'Monteserrat',
                    color: Colors.Text.DarkBlue,
                    align: 'center',
                })
                .setDepth(4)
                .setOrigin(0.5);

            const padding = 32;
            const labelWidth = this.add.text(0, 0, mot, {
                fontSize: `${10 * this.scaleX}px`,
                fontFamily: 'Monteserrat',
            }).width;
            rect.width = labelWidth + padding;
            rect.displayWidth = labelWidth + padding;
            label.setPosition(rect.x, rect.y);
            // Adjust rect.x to space mots clés based on their width
            if (i > 0) {
                const prevRect = motsClesRects[i - 1].rect;
                rect.x = prevRect.x + prevRect.displayWidth / 2 + rect.displayWidth / 2 + 24;
                label.setPosition(rect.x, rect.y);
            }
            rect.on('pointerdown', () => {
                motsClesRects.forEach(({ rect: r }) => r.setStrokeStyle(0, 0x000000));
                rect.setStrokeStyle(4, Colors.Elmt.BleuNovotel);
                this.mot = mot;
            });

            motsClesRects.push({ rect, label });
        });

        // ajouter le bouton
        // Track selected mot clé
        let selectedMotCle = null;

        const buttonValider = this.add
            .existing(
                new ButtonRounded(
                    this,
                    rightRectCenterX,
                    this.height - 32 - 32,
                    166 * 2,
                    32 * 2,
                    this.getText('Mission2', 'buttonLabel3'),
                    Colors.Text.White,
                    Colors.Elmt.BleuNovotel,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right-white',
                    null
                )
            )
            .setDepth(2)
            .setAlpha(1);

        buttonValider.on('pointerdown', () => {
            const reponse = this.getText('Mission2', 'reponse');
            if (this.mot === reponse) {
                this.tweens.add({
                    targets: [
                        blocker,
                        rightRect,
                        bouteilleVide,
                        textRectangle1,
                        textRectangle4,
                        buttonValider,
                        ...iconeHelps.map((icon) => icon.setAlpha(0)),
                        ...motsClesRects.map(({ rect, label }) => [rect, label]).flat(),
                        this.phrasesDebriefingTexts.forEach((textObj) => {
                            textObj.setAlpha(0);
                        }),
                    ],
                    alpha: 0,
                    duration: 100,
                    ease: 'Sine.easeIn',
                    onComplete: () => {
                        this.showEndScreen();
                        blocker.destroy();
                        rightRect.destroy();
                        bouteilleVide.destroy();
                        textRectangle1.destroy();
                        buttonValider.destroy();
                        textRectangle4.destroy();
                        motsClesRects.forEach(({ rect, label }) => {
                            rect.destroy();
                            label.destroy();
                        });
                        iconeHelps.forEach((icon) => icon.destroy());
                        this.phrasesDebriefingTexts.forEach((textObj) => textObj.destroy());
                        this.phrasesDebriefingTexts = [];
                    },
                });
            } else {
                // Show wrong image feedback
                const wrongIcon = this.add
                    .existing(
                        new AnswerFeedBack(
                            this,
                            rightRectCenterX,
                            rightRectCenterY,
                            'mauvaise-rep-activite-1',
                            this.getText('Mission2', 'mauvaiseReponse')
                        )
                    )
                    .setAlpha(0)
                    .setDepth(10);

                this.tweens.add({
                    targets: wrongIcon,
                    alpha: 1,
                    duration: 200,
                    yoyo: true,
                    hold: 500,
                    onComplete: () => {
                        wrongIcon.destroy();
                        // Remove all strokes from motsClesRects
                        motsClesRects.forEach(({ rect: r }) => r.setStrokeStyle(0, 0x000000));
                        selectedMotCle = null;
                        buttonValider.setLocked();
                    },
                });
            }
        });

        // Disable button initially
        buttonValider.setLocked();

        // Update motsClesRects to enable button when a mot clé is selected
        motsClesRects.forEach(({ rect }, i) => {
            rect.on('pointerdown', () => {
                selectedMotCle = i;
                buttonValider.setUnlocked();
            });
        });
    }

    hideActivite() {
        this.tweens.add({
            targets: this.UIactivite,
            alpha: 0,
            delay: 500,
            duration: 500,
            ease: 'Sine.easeIn',
        });
    }

    showActivite() {
        this.tweens.add({
            targets: this.UIactivite,
            alpha: 1,
            duration: 500,
            ease: 'Sine.easeIn',
        });
    }

    destroyActivite() {
        if (this.UIactivite) {
            this.UIactivite.forEach((el) => {
                if (el && typeof el.destroy === 'function' && !el.destroyed) {
                    el.destroy();
                }
            });
            this.UIactivite = [];
        }
        this.background.destroy();
    }

    showEndScreen() {
        const duration = 500;
        const elements = [];

        const blocker = this.add.rectangle(
            this.width / 2,
            this.height / 2,
            this.width,
            this.height,
            Colors.Elmt.Beige,
            1
        );

        // Nav (titre-nav-activite-1) – commence plus haut
        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '2', this.getText('Mission2', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();

        // ➡️ Titre avec animation spéciale
        const title = this.add
            .text(this.width / 2, this.height / 2 - 220, this.getText('Mission2', 'endTitre'), {
                fontSize: Sizes.Text.h1,
                color: Colors.Text.BleuNovotel,
                fontFamily: 'Binx',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        // ➡️ Autres éléments à animer ensuite
        const text1 = this.add
            .text(this.width / 2, this.height / 2 - 150, this.getText('Mission2', 'endTexte'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        this.addBouteille('Mission2');

        const icone = this.add
            .image(this.width / 2 - 420, this.height / 2 + 190, 'attention')
            .setAlpha(0)
            .setScale(0.5);

        const text2 = this.add
            .text(this.width / 2, this.height / 2 + 200, this.getText('Mission2', 'endTexte2'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
                align: 'center',
                wordWrap: { width: 368 * 2 },
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        elements.push(text1, this.bouteille, this.textBouteille, icone, text2);

        // ➡️ Bouton
        const button = this.add
            .existing(
                new ButtonRounded(
                    this,
                    this.width - 64 - 64,
                    this.height - 32 - 32,
                    86 * 2,
                    32 * 2,
                    this.getText('Mission2', 'buttonLabel1'),
                    Colors.Text.White,
                    Colors.Elmt.BleuNovotel,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right-white',
                    null
                )
            )
            .setAlpha(0)
            .setScale(0.5);

        elements.push(button);

        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.scene.start('Mission3');
        });

        // ➡️ Animation du titre : scale up + down + fade in
        this.tweens.add({
            targets: title,
            alpha: 1,
            scale: 1.2,
            duration: duration,
            ease: 'Back.Out',
            onComplete: () => {
                // ➡️ Retour à scale 1 (rebond)
                this.tweens.add({
                    targets: title,
                    scale: 1,
                    duration: 300,
                    ease: 'Back.Out',
                    onComplete: () => {
                        // ➡️ Quand le titre est fini : animer les autres éléments en cascade
                        elements.forEach((el, index) => {
                            this.tweens.add({
                                targets: el,
                                alpha: 1,
                                scale: 1,
                                ease: 'Back.Out',
                                duration: duration,
                                delay: index * 150,
                            });
                        });
                    },
                });
            },
        });
    }
}
